import { createSlice } from '@reduxjs/toolkit'

type CalendarState = {
  showCalendarLiveModal: boolean
  showCalendarTransitionModal: boolean
}

const initialState: CalendarState = {
  showCalendarLiveModal: false,
  showCalendarTransitionModal: true,
}

const calendarSlice = createSlice({
  name: 'calendar',
  initialState,
  reducers: {
    hideCalendarLiveModal(state) {
      state.showCalendarLiveModal = false
    },
    hideCalendarTransitionModal(state) {
      state.showCalendarTransitionModal = false
    },
    showCalendarLiveModal(state) {
      state.showCalendarLiveModal = true
    },
    showCalendarTransitionModal(state) {
      state.showCalendarTransitionModal = true
    },
  },
})

export const {
  hideCalendarLiveModal,
  hideCalendarTransitionModal,
  showCalendarLiveModal,
  showCalendarTransitionModal,
} = calendarSlice.actions
export default calendarSlice.reducer
